import { VehicleType } from './../types/VehicleType';

const AUTO_REPAIRS = [
  'Amortisseurs',
  'Batterie',
  'Boite de vitesses',
  'Carburateur',
  'Carrosserie',
  'Démarreur',
  'Direction',
  'Distribution',
  'Échappement',
  'Embrayage',
  'Freins',
  'Injection',
  'Moteur',
  'Peinture',
  'Pneus',
  'Radiateur',
  'Suspension',
  'Transmission',
];

const MOTO_REPAIRS = AUTO_REPAIRS.concat('Cadre', 'Fourche').sort();

export const VEHICLE_REPAIRS: Record<VehicleType, string[]> = {
  AUTO: AUTO_REPAIRS,
  MOTO: MOTO_REPAIRS,
  UTILITAIRE: AUTO_REPAIRS,
  CARAVANE: AUTO_REPAIRS,
  'CAMPING-CAR': AUTO_REPAIRS,
  UNKNOWN: [],
};
